import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, BadgeCheck, Users } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  avatar: string;
  title: string;
  body: string;
}
const testimonials: Testimonial[] = [{
  name: 'Mateo',
  age: 25,
  avatar: 'https://randomuser.me/api/portraits/men/62.jpg',
  title: 'Pensé que mi vida sexual se había acabado antes de empezar',
  body: 'Tras un fallo por puro estrés, entré en pánico. El Código Maestro me enseñó que mi cuerpo estaba bien, pero mi sistema nervioso estaba en llamas. La firmeza regresó la primera semana.'
}, {
  name: 'Carlos',
  age: 28,
  avatar: 'https://randomuser.me/api/portraits/men/46.jpg',
  title: 'La dopamina barata me tenía bloqueado',
  body: "El estrés, la sobreestimulación de redes y la pornografía me habían quitado la libido. Gracias al 'reset' de dopamina que enseña el libro, recuperé el deseo que no sentía desde los 18."
}, {
  name: 'David',
  age: 33,
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
  title: 'Recuperé la firmeza que creí perdida',
  body: 'A los 33 sentía que ya no era lo mismo. El Código me enseñó que mis arterias necesitaban nutrientes, no pastillas azules. Mi firmeza hoy es inquebrantable.'
}, {
  name: 'Sebastián',
  age: 37,
  avatar: 'https://randomuser.me/api/portraits/men/22.jpg',
  title: 'El manual de análisis clínicos me salvó',
  body: "Me sentía agotado y mi médico decía que todo era 'normal'. Con el Bonus 4 detecté mi deficiencia de Zinc y Vitamina D. En 21 días era otro hombre."
}, {
  name: 'Jorge',
  age: 41,
  avatar: 'https://randomuser.me/api/portraits/men/52.jpg',
  title: 'Fuego nuevo en mi matrimonio de 15 años',
  body: 'La rutina y la baja energía nos estaban matando. Este protocolo mejoró mi flujo sanguíneo y el Bonus 5 sobre el caudal dio una satisfacción que mi esposa y yo no esperábamos.'
}, {
  name: 'Ricardo',
  age: 53,
  avatar: 'https://randomuser.me/api/portraits/men/53.jpg',
  title: 'A los 50 también se rinde como un león',
  body: "Muchos me decían que a esta edad 'es lo que toca'. Mentira. Entender la hidráulica de mi cuerpo y optimizar mis hormonas naturalmente cambió las reglas del juego. Dureza total."
}];
export function Testimonials() {
  return <section className="py-24 bg-brand-dark relative overflow-hidden border-t border-brand-cardBorder" data-id="element-199">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-brand-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-200"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-202">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-brand-gold/30 bg-brand-gold/10 text-brand-gold text-sm font-semibold tracking-wide mb-6" data-id="element-203">
            <Users className="w-4 h-4" data-id="element-204" />
            HISTORIAS DE PODER
          </div>

          <h2 className="font-serif text-4xl sm:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-205">
            No estás solo. Más de{' '}
            <span className="text-brand-gold italic" data-id="element-206">12,000 hombres</span>
            <br className="hidden sm:block" data-id="element-207" /> ya han descifrado el Código.
          </h2>

          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-208">
            <div className="flex" data-id="element-209">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-gold text-brand-gold" data-id="element-210" />)}
            </div>
            <span className="text-brand-muted text-sm font-medium ml-2" data-id="element-211">
              4.9 / 5 basado en testimonios verificados
            </span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-212">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index % 3 * 0.1,
          duration: 0.5
        }} className="bg-brand-card border border-brand-cardBorder rounded-2xl p-7 relative hover:border-brand-gold/40 transition-all group flex flex-col" data-id="element-213">
              {/* Decorative quote icon */}
              <Quote className="absolute top-5 right-5 w-8 h-8 text-brand-gold/15 group-hover:text-brand-gold/30 transition-colors" data-id="element-214" />

              {/* Header: avatar + name + age */}
              <div className="flex items-center gap-4 mb-4" data-id="element-215">
                <div className="relative flex-shrink-0" data-id="element-216">
                  <img src={t.avatar} alt={`Retrato de ${t.name}`} loading="lazy" className="w-14 h-14 rounded-full object-cover border-2 border-brand-gold/40 shadow-[0_0_15px_rgba(212,162,76,0.15)]" data-id="element-217" />
                  <div className="absolute -bottom-1 -right-1 bg-brand-dark rounded-full p-0.5 border border-brand-cardBorder" data-id="element-218">
                    <BadgeCheck className="w-4 h-4 text-brand-gold fill-brand-gold/20" data-id="element-219" />
                  </div>
                </div>
                <div data-id="element-220">
                  <div className="flex items-center gap-1.5" data-id="element-221">
                    <h4 className="text-white font-bold text-base" data-id="element-222">{t.name}</h4>
                    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-brand-gold/10 border border-brand-gold/30 text-[10px] font-semibold text-brand-gold uppercase tracking-wider" data-id="element-223">
                      Verificado
                    </span>
                  </div>
                  <p className="text-xs text-brand-muted font-medium mt-0.5" data-id="element-224">
                    {t.age} años · Cliente real
                  </p>
                </div>
              </div>

              {/* Stars */}
              <div className="flex gap-0.5 mb-4" data-id="element-225">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-226" />)}
              </div>

              {/* Title */}
              <h3 className="font-serif text-lg font-bold text-brand-gold mb-3 leading-snug italic" data-id="element-227">
                "{t.title}"
              </h3>

              {/* Body */}
              <p className="text-brand-text/80 text-sm leading-relaxed flex-1" data-id="element-228">
                {t.body}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}